import { API_URL } from '../../../app-config/constants';
import type { UserImportSystem } from '../../../types/UserImport';
import { get, post } from '../request';

const BASE = `${API_URL}/user-import`;

const getQuery = (companyId?: string) => {
    const companyQuery = companyId ? `&company=${companyId}` : '';
    return `?fields=$user-import.list${companyQuery}`;
};

export interface UserImportApi {
    getHistory: (companyId: string) => Promise<{}>;
    getHistoryDetails: (id: string) => Promise<{}>;
    startPreview: (companyId: string) => Promise<{}>;
    getPreview: (id: string) => Promise<{}>;
    doPreview: (companyId: string) => Promise<{}>;
    doImport: () => Promise<{}>;
}

export function createApi(system: UserImportSystem) {
    return {
        getHistory: (companyId: string) => {
            return get(`${BASE}/${system}/simulations${getQuery(companyId)}`);
        },

        getHistoryDetails: (id: string) => {
            return get(`${BASE}/${system}/simulation/${id}${getQuery()}`);
        },
        startPreview: (companyId: string) => {
            return post(`${BASE}/${system}/preview${getQuery(companyId)}`, { postData: null });
        },
        getPreview: (id: string) => {
            return get(`${BASE}/${system}/preview/${id}${getQuery()}`);
        },
        doPreview: (companyId: string) => {
            return post(`${BASE}/${system}/simulate${getQuery(companyId)}`, { postData: null });
        },

        doImport: () => {
            return post(`${BASE}/${system}`, { postData: null });
        },
    };
}
